import { AppConnectionStatuses } from 'integrations-lib/constants/appConnectionStatuses';
import { NotificationStatusTag } from './NotificationStatusTag';
import { NotificationStatusRibbon } from './NotificationStatusRibbon';
import { jsx as _jsx } from "react/jsx-runtime";
export const NotificationStatusView = ({
  statusesList,
  type = 'tag',
  ribbonProps,
  underline
}) => {
  const notificationStatus = statusesList.find(item => {
    var _item$metadata;
    return ((_item$metadata = item.metadata) === null || _item$metadata === void 0 ? void 0 : _item$metadata.category) === 'NOTIFICATION' && item.type !== AppConnectionStatuses.NO_STATUS_AVAILABLE;
  });
  if (!notificationStatus) {
    return null;
  }
  if (type === 'tag') {
    return /*#__PURE__*/_jsx(NotificationStatusTag, {
      statusText: notificationStatus.status,
      underline: underline
    });
  }
  return /*#__PURE__*/_jsx(NotificationStatusRibbon, Object.assign({
    statusText: notificationStatus.status
  }, ribbonProps));
};